<script setup lang="ts">
import { computed } from 'vue'

import { useNotifyStore } from '@/stores/notify'

const notify = useNotifyStore()
const open = computed({
  get: () => notify.current !== null,
  set: (value) => {
    if (!value) notify.clear()
  },
})
</script>

<template>
  <v-snackbar
    :key="notify.current?.id"
    v-model="open"
    :color="notify.current?.color"
    :timeout="notify.current?.timeout"
    location="bottom center"
    rounded="lg"
    role="status"
  >
    {{ notify.current?.text }}
  </v-snackbar>
</template>
